export default function Notifications() {
  return (
    <div className="p-6">
      <h1 className="text-xl font-semibold text-slate-800">Notifications</h1>
      <p className="text-slate-600 mt-2">Coming soon.</p>
    </div>
  );
}
